import type { CollectionName } from "./pb";

/**
 * Query key factory.
 *
 * Every collection-backed query must be keyed with `queryKeys.collection(name,
 * ...)` so that a realtime event on that collection can invalidate all of its
 * queries with a single prefix match, regardless of the filters a feature added.
 */

export const queryKeys = {
  /** Reachability of the Kobo server. */
  health: ["server", "health"] as const,

  /** The signed-in user record. */
  session: ["session"] as const,

  /**
   * All queries reading `collection`. Extra segments narrow it further:
   * `queryKeys.collection("tasks", { date })`.
   */
  collection: (collection: CollectionName, ...scope: readonly unknown[]) =>
    ["collection", collection, ...scope] as const,
} as const;
